export default {
  noDeclaration: 'aucune déclaration',
  filterByApp: 'Filtrer par app',
  captured: 'pris',
  zendeskTicketsOnDeclaration:
    'un(des) réclamation(s) Zendesk présentes sur cette déclaration'
}
